import { Outlet, useLocation } from 'react-router-dom';

/**
 * Remounts the active route when the workspace tab (pathname) changes.
 * Ensures mount-time entity fetches run per tab instead of reusing stale Redux singleton data.
 */
const WorkspaceRouteOutlet = () => {
  const { pathname } = useLocation();
  return <Outlet key={pathname} />;
};

export default WorkspaceRouteOutlet;
